<template>
  <div class="columns">
    <div class="column">
      <p class="subtitle">
        {{ $t("info") }}
      </p>
      <tr>
        <td>
          <b-field :label="$t('legalEmail')" />
        </td>
        <td>
          <b-input v-model="props.row.legalEmail" />
        </td>
      </tr>
      <tr>
        <td><b-field :label="$t('telephoneNumber')" /></td>
        <td>
          <PhoneNumberPicker v-model="props.row.telephoneNumber" :required="props.row.mobileNumber ? false : true" />
        </td>
      </tr>
      <tr>
        <td><b-field :label="$t('mobileNumber')" /></td>
        <td>
          <PhoneNumberPicker v-model="props.row.mobileNumber" :required="props.row.telephoneNumber ? false : true" />
        </td>
      </tr>
      <tr>
        <td>
          <b-field :label="$t('legalStreetName')" />
        </td>
        <td>
          <b-input v-model="props.row.legalStreetName" />
        </td>
      </tr>
      <tr>
        <td>
          <b-field :label="$t('legalCity')" />
        </td>
        <td>
          <b-input v-model="props.row.legalCity" />
        </td>
      </tr>
      <tr>
        <td>
          <b-field :label="$t('legalZipCode')" />
        </td>
        <td>
          <b-input v-model="props.row.legalZipCode" />
        </td>
      </tr>
      <tr>
        <td>
          <b-field :label="$t('legalCountry')" />
        </td>
        <td>
          <CountryPicker v-model="props.row.legalCountry" :is-loading="isLoading" :title="false" />
        </td>
      </tr>
      <tr>
        <td>
          <b-field :label="$t('vatId')" />
        </td>
        <td>
          <b-input v-model="props.row.vatId" />
        </td>
      </tr>
      <tr>
        <td>
          <b-field :label="$t('approvedForPaymentOnInvoice')" />
        </td>
        <td>
          <b-switch v-model="props.row.approvedForPaymentOnInvoice">
            {{ props.row.approvedForPaymentOnInvoice ? $t("Yes") : $t("No") }}
          </b-switch>
        </td>
      </tr>
      <tr>
        <td>
          <b-field :label="$t('isSubscriber')" />
        </td>
        <td>
          <b-switch v-model="props.row.isSubscriber">
            {{ props.row.isSubscriber ? $t("Yes") : $t("No") }}
          </b-switch>
        </td>
      </tr>
      <tr>
        <td>
          <b-field :label="$t('isBroker')" />
        </td>
        <td>
          <b-switch v-model="props.row.isBroker">
            {{ props.row.isBroker ? $t("Yes") : $t("No") }}
          </b-switch>
        </td>
      </tr>
      <tr>
        <td>
          <b-field :label="$t('brokerApproved')" />
        </td>
        <td>
          <b-switch v-model="props.row.brokerApproved">
            {{ props.row.brokerApproved ? $t("Yes") : $t("No") }}
          </b-switch>
        </td>
      </tr>
      <tr>
        <td>
          <b-field :label="$t('brokerSigned')" />
        </td>
        <td>
          <b-switch v-model="props.row.brokerSigned">
            {{ props.row.brokerSigned ? $t("Yes") : $t("No") }}
          </b-switch>
        </td>
      </tr>
      <tr style="display: none">
        <td>
          <b-field :label="$t('isAffiliate')" />
        </td>
        <td>
          <b-switch v-model="props.row.isAffiliate">
            {{ props.row.isAffiliate ? $t("Yes") : $t("No") }}
          </b-switch>
        </td>
      </tr>
      <tr>
        <td>
          <b-field :label="$t('isChildOf')" />
        </td>
        <td>
          <b-input v-model="props.row.isChildOf" />
        </td>
      </tr>
      <b-button class="is-info mt-4 mb-4 mr-4" :loading="isLoading" @click="confirmChanges">
        {{ $t("saveChanges") }}
      </b-button>
      <b-button class="is-info mt-4 mb-4 mr-4" :loading="isLoading" @click="approvePartner">
        {{ $t("approvePartner") }}
      </b-button>
      <b-field v-if="props.row.created" class="mt-4">
        <span>
          <i>{{ $t("created") + ": " + props.row.created.toDate().toLocaleString().split(",")[0] }}</i>
        </span>
      </b-field>
    </div>

    <div class="column">
      <p class="subtitle">
        {{ $t("admins") }}
      </p>
      <tr v-for="(info, field) in admins" :key="field">
        <td>{{ info.email }}</td>
        <td>{{ info.firstName + " " + info.lastName }}</td>
      </tr>
      <p class="subtitle mt-4">
        {{ $t("brokerRegistration") }}
      </p>
      <div v-for="(a, i) in applications" :key="i">
        <b-field :label="$t('applicationText')">
          <b-input v-model="a.applicationText" maxlength="4000" type="textarea" :disabled="true" />
        </b-field>
        <div v-for="(f, k) in a.applicationFiles" :key="k" class="mb-3">
          <a :href="f.url" target="_blank">
            <b-button type="is-primary is-light">
              {{ f.name }}
            </b-button>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db, functions } from "@/firebase";
import CountryPicker from "@/components/CountryPicker";
import PhoneNumberPicker from "@/components/PhoneNumberPicker";

export default {
  name: "OrganizationInfo",
  components: {
    CountryPicker,
    PhoneNumberPicker,
  },
  props: {
    props: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      admins: [],
      isLoading: false,
      modalActive: false,
      parentId: "",
      applications: [],
    };
  },
  methods: {
    async approvePartner() {
      this.isLoading = true;
      functions
        .httpsCallable("ApprovePartner")({ organizationId: this.props.row.id })
        .then(() => {
          this.$buefy.toast.open({
            message: this.$t("brokerApproved"),
            type: "is-success",
          });
        })
        .catch((err) => {
          this.$buefy.toast.open({
            message: err,
            type: "is-danger",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    confirmChanges() {
      this.$buefy.dialog.confirm({
        title: this.$t("saveChanges"),
        message: this.$t("changeInfoInfo"),
        confirmText: this.$t("saveChanges"),
        cancelText: this.$t("cancel"),
        type: "is-info",
        closeOnConfirm: true,
        hasIcon: true,
        onConfirm: async () => {
          this.isLoading = true;
          await this.saveChanges();
          this.isLoading = false;
          this.$parent.closeDetailRow();
        },
      });
    },
    async saveChanges() {
      let data = {
        legalEmail: this.props.row.legalEmail,
        legalStreetName: this.props.row.legalStreetName,
        legalCity: this.props.row.legalCity,
        legalCountry: this.props.row.legalCountry,
        legalZipCode: this.props.row.legalZipCode,
        telephoneNumber: this.props.row.telephoneNumber || null,
        mobileNumber: this.props.row.mobileNumber || null,
        vatId: this.props.row.vatId || "",
        isAffiliate: this.props.row.isAffiliate || false,
        approvedForPaymentOnInvoice: this.props.row.approvedForPaymentOnInvoice || false,
        isSubscriber: this.props.row.isSubscriber || false,
        isBroker: this.props.row.isBroker || false,
        brokerApproved: this.props.row.brokerApproved || false,
        brokerSigned: this.props.row.brokerSigned || false,
      };
      if (this.props.row.isChildOf) {
        if (this.props.row.isChildOf.length !== 0) {
          if ((await db.collection("organizations").doc(this.props.row.isChildOf).get()).exists) {
            db.collection("organizations")
              .doc(this.props.row.id)
              .set(data, { merge: true })
              .then(() => {
                this.$buefy.toast.open({
                  message: this.$t("settingsSaved"),
                  type: "is-success",
                });
              })
              .catch((err) => {
                this.$buefy.toast.open({
                  message: err,
                  type: "is-danger",
                });
              });
          } else {
            this.$buefy.toast.open({
              message: this.$t("parentNotExisting"),
              type: "is-danger",
            });
          }
        }
      } else {
        db.collection("organizations")
          .doc(this.props.row.id)
          .set(data, { merge: true })
          .then(() => {
            this.$buefy.toast.open({
              message: this.$t("settingsSaved"),
              type: "is-success",
            });
          })
          .catch((err) => {
            this.$buefy.toast.open({
              message: err,
              type: "is-danger",
            });
          });
      }
    },
  },
  firestore() {
    return {
      admins: db.collection("organizations").doc(this.props.row.id).collection("admins"),
      applications: db
        .collection("organizations")
        .doc(this.props.row.id)
        .collection("applications")
        .orderBy("timestamp", "desc")
        .limit(1),
    };
  },
};
</script>
